'use client';
import Loading from '@koda/koda-assets/icons/loading.svg';
import { forwardRef, InputHTMLAttributes } from 'react';
import { cn } from '../../lib/utils/classnameVariants';

const LoadingContainer = forwardRef<HTMLDivElement, InputHTMLAttributes<HTMLDivElement>>(
  ({ className, ...props }, ref) => (
    <div
      {...props}
      ref={ref}
      className={cn(
        'flex h-[142px] w-full items-center justify-center rounded-2xl rounded-bl-none bg-black-50 sm:h-[183px]',
        className,
      )}
    >
      <Loading className="size-6 animate-spin fill-black-500" />
    </div>
  ),
);

LoadingContainer.displayName = 'LoadingContainer';

export { LoadingContainer };
